module.exports = __webpack_public_path__ + "static/media/ea.b8702e7d.png";